import React, { Component } from "react";
import Localization from "../../localization";

class Progress extends Component {
    render() {
        const { percentage, locale } = this.props;

        return (
            <div className="flex-1">
                <div className="flex">
                    <p className="font-bold text-30 xl:text-17">
                        {percentage + "%"}
                    </p>
                    <p className="font-bold hidden xl:block text-30 ml-5 xl:text-17">
                        {Localization[locale].validation.completed}
                    </p>
                </div>
                <div className="relative mt-6 w-100 xl:w-200">
                    <div className="h-4 bg-black bg-opacity-20" />
                    <div
                        style={{ width: percentage + "%" }}
                        className="h-4 bg-blue absolute transition-all duration-300 ease-in-out top-0 left-0"
                    />
                </div>
            </div>
        );
    }
}

Progress.defaultProps = {};

export default Progress;
